export default {
  mount: '.icon-add',
  attrs: {
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  },
  path: '<path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M13.3733333,8.12666667 L6,15.5 L6,18 L8.5,18 L15.8733333,10.6266667 L13.3733333,8.12666667 Z M15.3066667,6.19333333 L14.0866667,7.41333333 L16.5866667,9.91333333 L17.8066667,8.69333333 C18.0666667,8.43333333 18.0666667,8.01333333 17.8066667,7.75333333 L16.2466667,6.19333333 C15.9866667,5.93333333 15.5666667,5.93333333 15.3066667,6.19333333 Z"></path>'
}
